/***
*
*   HOME LAYOUT
*   Main website layout
*
**********/

import React, { Fragment } from 'react';
import { HomeNav, Footer, useLocation, QuickLinks } from 'components/lib';

export function HomeLayout(props){

  const location = useLocation();
  const transparent = location?.pathname === '/' ? false : false;

  return (
    <Fragment>
      <main className='home'>

        <HomeNav transparent={ transparent } />
        {/*<QuickLinks small external />  */}
        { <props.children {...props.data }/> }

      </main>
      <Footer />
    </Fragment>
  );
}
